import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  // Fonction pour remonter en haut de la page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Fonction pour gérer la soumission de la newsletter
  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // Ici vous pouvez ajouter la logique pour traiter l'inscription à la newsletter
    const email = e.target.email.value;
    console.log("Newsletter subscription:", email);
    // Exemple: appel API pour inscription
  };

  return (
    <footer className="footer py-5">
      <div className="container">
        {/* Section principale du footer */}
        <div className="row gy-4 mb-5">
          {/* Colonne logo et adresse */}
          <div className="col-12 col-md-4 mb-md-0">
            <div className="footer-brand mb-4">
              <Link to="/" className="text-decoration-none">
                <img
                  src="/logo192.png"
                  alt="BoxPlaisir Logo"
                  className="footer-logo me-2"
                  width="32"
                  height="32"
                />
                <span className="fw-bold h5 mb-0">
                  <span style={{ color: "#666666" }}>Box</span>
                  <span style={{ color: "#543ba4" }}>Plaisir</span>
                </span>
              </Link>
            </div>
            <address className="footer-address mb-4 d-flex flex-column">
              <span>All Diffusion SNC</span>
              <span>Rue du Château 13</span>
              <span>5190 Jemeppe-sur-Sambre</span>
              <span>Belgique</span>
              <span className="mt-1">TVA : BE1016199219</span>
            </address>
            <div className="social-icons d-flex gap-2 mb-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Suivez-nous sur Facebook"
              >
                <i className="bi bi-facebook"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Suivez-nous sur Instagram"
              >
                <i className="bi bi-instagram"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Suivez-nous sur Twitter"
              >
                <i className="bi bi-twitter-x"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Suivez-nous sur LinkedIn"
              >
                <i className="bi bi-linkedin"></i>
              </a>
            </div>
          </div>

          {/* Colonne liens utiles */}
          <div className="col-6 col-md-2 offset-md-1">
            <h5 className="footer-heading mb-3">Navigation</h5>
            <ul className="list-unstyled footer-links">
              <li className="mb-2">
                <Link to="/" className="footer-link">
                  <i className="bi bi-house-door me-2" aria-hidden="true"></i>
                  Accueil
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/category" className="footer-link">
                  <i className="bi bi-box me-2" aria-hidden="true"></i>
                  Nos box
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/how-it-works" className="footer-link">
                  <i className="bi bi-info-circle me-2" aria-hidden="true"></i>
                  Comment ça marche
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/profile" className="footer-link">
                  <i className="bi bi-person me-2" aria-hidden="true"></i>
                  Mon compte
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/cart" className="footer-link">
                  <i className="bi bi-cart3 me-2" aria-hidden="true"></i>
                  Panier
                </Link>
              </li>
            </ul>
          </div>

          {/* Colonne informations */}
          <div className="col-6 col-md-2">
            <h5 className="footer-heading mb-3">Informations</h5>
            <ul className="list-unstyled footer-links">
              <li className="mb-2">
                <Link to="/about" className="footer-link">
                  <i className="bi bi-info-circle me-2" aria-hidden="true"></i>
                  À propos
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/contact" className="footer-link">
                  <i className="bi bi-envelope me-2" aria-hidden="true"></i>
                  Contact
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/faq" className="footer-link">
                  <i className="bi bi-question-circle me-2" aria-hidden="true"></i>
                  FAQ
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/blog" className="footer-link">
                  <i className="bi bi-journal-text me-2" aria-hidden="true"></i>
                  Blog
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/shipping" className="footer-link">
                  <i className="bi bi-truck me-2" aria-hidden="true"></i>
                  Livraison
                </Link>
              </li>
            </ul>
          </div>

          {/* Colonne légale */}
          <div className="col-12 col-md-3">
            <h5 className="footer-heading mb-3">Informations légales</h5>
            <ul className="list-unstyled footer-links">
              <li className="mb-2">
                <Link to="/privacy-policy" className="footer-link">
                  <i className="bi bi-shield-lock me-2" aria-hidden="true"></i>
                  Politique de confidentialité
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/terms-of-service" className="footer-link">
                  <i className="bi bi-file-text me-2" aria-hidden="true"></i>
                  Conditions d'utilisation
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/legal-notice" className="footer-link">
                  <i className="bi bi-file-earmark-text me-2" aria-hidden="true"></i>
                  Mentions légales
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/cookies" className="footer-link">
                  <i className="bi bi-cookie me-2" aria-hidden="true"></i>
                  Politique des cookies
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/returns" className="footer-link">
                  <i className="bi bi-arrow-repeat me-2" aria-hidden="true"></i>
                  Retours et remboursements
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Section newsletter - Plus élégante */}
        <div className="row mb-5">
          <div className="col-12">
            <div className="p-4 newsletter-section">
              <div className="row align-items-center">
                <div className="col-md-6 mb-3 mb-md-0">
                  <h5 className="newsletter-title mb-2">
                    <i
                      className="bi bi-envelope-check me-2"
                      style={{ color: "#f89638" }}
                      aria-hidden="true"
                    ></i>
                    Restez informé
                  </h5>
                  <p className="text-muted mb-0 small">
                    Inscrivez-vous à notre newsletter pour recevoir nos offres
                    exclusives et les dernières nouveautés
                  </p>
                </div>
                <div className="col-md-6">
                  <form className="d-flex" onSubmit={handleNewsletterSubmit}>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Votre email"
                      aria-label="Adresse email pour la newsletter"
                      required
                    />
                    <button type="submit" className="btn newsletter-btn ms-2">
                      S'inscrire
                    </button>
                  </form>
                  <div className="form-text mt-2 small">
                    <i
                      className="bi bi-shield-check me-1"
                      style={{ color: "#543ba4" }}
                      aria-hidden="true"
                    ></i>
                    Nous respectons votre vie privée et ne partagerons jamais
                    vos données
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Section paiement et livraison */}
        <div className="row mb-4">
          <div className="col-md-6 mb-4 mb-md-0">
            <p className="text-muted mb-3 small d-flex align-items-center">
              <i
                className="bi bi-credit-card me-2"
                style={{ color: "#543ba4" }}
                aria-hidden="true"
              ></i>
              <strong>Moyens de paiement acceptés</strong>
            </p>
            <div className="payment-methods d-flex flex-wrap gap-2">
              <span className="payment-icon" title="Visa">
                <i className="bi bi-credit-card-fill" aria-hidden="true"></i>
              </span>
              <span className="payment-icon" title="Mastercard">
                <i className="bi bi-credit-card" aria-hidden="true"></i>
              </span>
              <span className="payment-icon" title="PayPal">
                <i className="bi bi-paypal" aria-hidden="true"></i>
              </span>
              <span className="payment-icon" title="Bancontact">
                <i className="bi bi-bank" aria-hidden="true"></i>
              </span>
              <span className="payment-icon" title="Virement bancaire">
                <i className="bi bi-cash-coin" aria-hidden="true"></i>
              </span>
              <span className="payment-icon" title="Apple Pay">
                <i className="bi bi-apple" aria-hidden="true"></i>
              </span>
            </div>
          </div>
          <div className="col-md-6">
            <p className="text-muted mb-3 small d-flex align-items-center">
              <i className="bi bi-truck me-2" style={{ color: "#543ba4" }} aria-hidden="true"></i>
              <strong>Livraison</strong>
            </p>
            <div className="d-flex flex-wrap gap-3">
              <div className="d-flex align-items-center">
                <span className="badge bg-light text-dark border d-flex align-items-center me-2">
                  <i
                    className="bi bi-check-circle-fill me-1"
                    style={{ color: "#543ba4" }}
                    aria-hidden="true"
                  ></i>
                </span>
                <span className="small">Livraison gratuite dès 50€</span>
              </div>
              <div className="d-flex align-items-center">
                <span className="badge bg-light text-dark border d-flex align-items-center me-2">
                  <i
                    className="bi bi-check-circle-fill me-1"
                    style={{ color: "#543ba4" }}
                    aria-hidden="true"
                  ></i>
                </span>
                <span className="small">2-3 jours ouvrés en Belgique</span>
              </div>
              <div className="d-flex align-items-center">
                <span className="badge bg-light text-dark border d-flex align-items-center me-2">
                  <i
                    className="bi bi-check-circle-fill me-1"
                    style={{ color: "#543ba4" }}
                    aria-hidden="true"
                  ></i>
                </span>
                <span className="small">Livraison internationale</span>
              </div>
            </div>
          </div>
        </div>

        {/* Section copyright - Plus élégante */}
        <hr className="my-4" />
        <div className="row justify-content-between align-items-center">
          <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
            <p className="footer-copyright mb-0">
              Made with <span style={{ color: "red" }} aria-hidden="true">❤️</span> by{" "}
              <a
                href="https://cyberglow.be"
                target="_blank"
                rel="noopener noreferrer"
              >
                CyberGlow
              </a>
            </p>
          </div>
          <div className="col-md-6 text-center text-md-end">
            <button
              type="button"
              onClick={scrollToTop}
              className="back-to-top btn btn-link p-0"
              aria-label="Retourner en haut de la page"
            >
              Haut de page
              <i className="bi bi-arrow-up-circle ms-1" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;